export default __webpack_public_path__ + "static/media/fempulse.560afb9e.png";